export const appConstConfig = {
  DEFAULT_TABLE_PAGE_NUMBER: 1,
  DEFAULT_TABLE_PAGE_SIZE: 10,
  DEFAULT_PAGE_SIZE_OPTIONS_ARR: ["10", "15", "20"],
  DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA: 255,
  PASSWORD_VALIDATION_REGEX : /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
};
